export default {
  getColunas(state) {
    return state.colunasQuestionarios;
  },
  getFiltros(state) {
    return state.filtros;
  },
  getQuestionarios(state) {
    return state.questionarios;
  },
};
